
import React, { Component } from 'react';
import { confirmForgotPassword } from '../utils/forgot-password';
class NewPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            otp: '',
            newPassword: '',
            confirmPassword: ''
        };
    }

    // Handle input changes
    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    // Handle form submission
    
handleNewPassword = async (e) => {
    e.preventDefault(); // Prevent page refresh
    const { newPassword, confirmPassword } = this.state;
    const { username, onChangeView } = this.props
    // Password validation regex
    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.])[A-Za-z\d@$!%*?&.]{8,}$/;
    if (newPassword !== confirmPassword) {
        alert("Passwords do not match!");
    } else if (!passwordRegex.test(newPassword)) {
        alert("Password must be at least 8 characters long, contain one uppercase letter, one number, and one special character.");
    } else {
        try {
            let result = await confirmForgotPassword(username,this.state.otp,newPassword);
            alert("New Password Set Succesfully")
            onChangeView?.('Login');
        } catch (error) {
            console.log("Error occurs ",error);
        }
    }
};


    render() {
        return (
            <div className='swagger-ui'>
                <div className='newpassword-container'>
                    <div className='forgot-heading'>
                        <span className='forgot-form-heading'>Forgot Password</span>
                    </div>
                    <form className='newpassword-form' onSubmit={this.handleNewPassword}>
                        <label className='newpassword-label'>Enter OTP</label>
                        <input
                            type='number'
                            name='otp'
                            value={this.state.otp}
                            onChange={this.handleChange}
                            className='newpassword-input'
                        />

                        <label className='newpassword-label2'>New Password</label>
                        <input
                            type='password'
                            name='newPassword'
                            value={this.state.newPassword}
                            onChange={this.handleChange}
                            className='newpassword-input'
                        />

                        <label className='newpassword-label'>Confirm Password</label>
                        <input
                            type='password'
                            name='confirmPassword'
                            value={this.state.confirmPassword}
                            onChange={this.handleChange}
                            className='newpassword-input'
                        />

                        <button type="submit" className='newPasswordbutton'>Submit</button>
                    </form>
                </div>
            </div>
        );
    }
}

export default NewPassword;